/**
 * SAT Generator 3.0 — Main Entry (PR-D4-031 MadCrab CSS foundation)
 */

import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import 'katex/dist/katex.min.css';
import './index.css';
import './madcrab/App.css';
import './madcrab/SatTest.css';

const rootElement = document.getElementById('root');

if (!rootElement) {
    throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
